<template>
  <div class="row" v-if="isShow">
    <div class="col col-6">
      <div class="form-label">Основной раздел</div>
      <select
          v-model="fields.type_id"
          class="form-select"
          @change="changeTypeId"
      >
        <option
            v-for="item in filteredTypeIds"
            :key="item.value"
            :value="item.value"
        >
          {{ item.name }}
        </option>
      </select>
    </div>

    <div class="col col-6">
      <div class="form-label">&nbsp;</div>
      <template v-if="isShowAdditionalSection">
        <Select
            :payload="{
            value: fields.sub_type_ids,
            items: filteredSubTypeIds,
            label: 'Доп. раздел',
            validator: {},
          }"
            @onChangeVal="changeSubTypeIds"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import Select from './components/select/Index'
import Helper from '@/services/Helper'

const props = defineProps({
  payload: { type: Object, default: () => ({}) }
})
const emit = defineEmits(['onChange'])

const show = ref(false)
const typeIds = ref([])

const fields = reactive({
  type_id: null,
  sub_type_ids: [],
})

onMounted(async () => {
  updateFields(props.payload)
  typeIds.value = await getTypeIdsApi()
  show.value = true
})

function updateFields(payload) {
  fields.type_id = payload.type_id ?? null
  fields.sub_type_ids = payload.sub_type_ids ?? []
}

async function getTypeIdsApi() {
  return [
    { value: 5, name: 'Заметка' },
    { value: 6, name: 'Скидки' },
    { value: 7, name: 'Промокоды' },
    { value: 8, name: 'Акции' },
    { value: 9, name: 'Халява' },
    { value: 10, name: 'Еда и продукты' },
    { value: 12, name: 'Банки' },
    { value: 13, name: 'Игры' },
    { value: 14, name: 'Розыгрыши' },
    { value: 15, name: 'Статьи' },
  ]
}

/* handlers */
function changeTypeId(e) {
  const newTypeId = Number(e.target.value)
  fields.type_id = newTypeId

  // Убираем выбранный type_id из sub_type_ids
  fields.sub_type_ids = fields.sub_type_ids.filter(id => id !== newTypeId)

  pushEvent()
}

function changeSubTypeIds(items) {
  // sub_type_ids не могут содержать текущий type_id
  fields.sub_type_ids = items.sub_type_id.filter(id => id !== fields.type_id)
  pushEvent()
}

function pushEvent() {
  emit('onChange', {
    type_id: fields.type_id,
    sub_type_ids: fields.sub_type_ids
  })
}

/* computed */
const isShow = computed(() => show.value)
const isShowAdditionalSection = computed(() => {
  return !Helper.inArray([fields.type_id], [5,6,7,8,15])
})

// typeIds для выбора type_id — исключаем элементы, уже выбранные в sub_type_ids
const filteredTypeIds = computed(() => {
  return typeIds.value.filter(item => !fields.sub_type_ids.includes(item.value))
})

// typeIds для sub_type_ids — исключаем текущий type_id и "Заметку"
const filteredSubTypeIds = computed(() => {
  return typeIds.value.filter(
      item => item.value !== fields.type_id && item.value !== 5 && item.value !== 7
  )
})
</script>
